import { IntlShape } from 'react-intl';

const formatSeconds = (intl: IntlShape, seconds: number): string => {
    if (/ru/.test(intl.locale)) {
        return `${intl.formatNumber(seconds)} sec`;
    }
    return intl.formatNumber(seconds, {
        style: 'unit',
        unit: 'second',
        unitDisplay: 'short',
    });
};

const formatMinutes = (intl: IntlShape, minutes: number): string =>
    intl.formatNumber(minutes, {
        style: 'unit',
        unit: 'minute',
        unitDisplay: 'short',
    });

const formatHours = (intl: IntlShape, hours: number): string =>
    intl.formatNumber(hours, {
        style: 'unit',
        unit: 'hour',
        unitDisplay: 'short',
    });

export function splitTime(seconds: number): number[] {
    let hours = 0;
    let mins = 0;
    let secs = seconds;
    if (secs) {
        hours = Math.floor(secs / 3600);
        secs -= hours * 3600;
        mins = Math.floor(secs / 60);
        secs -= mins * 60;
    }

    return [hours, mins, secs];
}

export function formatDuration(intl: IntlShape, duration: number, withSeconds = true): string {
    const [hours, mins, secs] = splitTime(duration);

    if (withSeconds && !hours && !mins && secs) {
        return formatSeconds(intl, duration);
    }

    let timeText = '';

    if (hours) {
        timeText += formatHours(intl, hours);
    }

    if (mins) {
        timeText += `${hours ? ' ' : ''}${formatMinutes(intl, mins)}`;
    }

    return timeText;
}
const formatDurationFromMinutes = (intl: IntlShape, duration: number): string => {
    const hours = Math.floor(duration / 60);
    const minutes = Math.floor(duration % 60);

    let timeText = '';
    if (hours) {
        timeText += formatHours(intl, hours);
    }

    if (minutes) {
        timeText += `${hours ? ' ' : ''}${formatMinutes(intl, minutes)}`;
    }

    return timeText;
};

export const formatDurationFromSeconds = (intl: IntlShape, duration: number): string =>
    formatDurationFromMinutes(intl, duration / 60);
